function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M905,708.66C905,817.08,817.08,905,708.66,905S512.35,817.08,512.35,708.66s87.89-196.31,196.31-196.31c79.94,0,134.48,52.95,141.34,60.08C857.74,580.45,905,633,905,708.66Z",
  transform: "translate(-484.85 -484.85)",
  fill: "none",
  stroke: "#e5daca",
  strokeMiterlimit: 10,
  strokeWidth: 55
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M527,634.22a200.9,200.9,0,0,1,45.69-67.12,195.61,195.61,0,0,1,124.55-54.41c7.77-.45,13.87-.34,16.76-.25a193.13,193.13,0,0,1,47.48,7.69,212.94,212.94,0,0,1,53.18,24.37,221,221,0,0,1,28.85,21.71",
  transform: "translate(-484.85 -484.85)",
  fill: "none",
  stroke: "#282c34",
  strokeMiterlimit: 10,
  strokeWidth: 65
});

var SvgSpinner = function SvgSpinner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 447.62 447.62",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpinner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spinner.7b8cc179.svg";
export { ForwardRef as ReactComponent };